import React from "react"
import Layout from "../../components/layout"
import SEO from "../../components/seo"
import CoverageTemplate, {
  CoverageType,
} from "../../components/coverage-template"

import {
  CoverageCommercialRealEstateMeta,
  CoverageVacantBuildingsMeta,
} from "../../data/seo-meta"

import { VacantBuildingsBrochure } from "../../data/brochures"

import vacantBuildingsIcon from "../../images/coverage/product/vacant-buildings.svg"

const related = [
  {
    name: "Commercial Real Estate",
    href: CoverageCommercialRealEstateMeta.path,
  },
]

const downloads = [
  { name: "Brochure - Vacant Buildings", href: VacantBuildingsBrochure },
]

const CoverageVacantBuildingsPage = () => (
  <Layout>
    <SEO
      description={CoverageVacantBuildingsMeta.description}
      path={CoverageVacantBuildingsMeta.path}
      title={CoverageVacantBuildingsMeta.title}
    />
    <CoverageTemplate
      icon={vacantBuildingsIcon}
      type={CoverageType.Product}
      title={CoverageVacantBuildingsMeta.title}
      description={CoverageVacantBuildingsMeta.description}
      related={related}
      downloads={downloads}
    >
      <h3 className="h3">TARGET RISKS</h3>
      <ul>
        <li>New construction awaiting certificate of occupancy</li>
        <li>New property acquisitions</li>
        <li>Real estate development property</li>
        <li>Businesses that are temporarily closed</li>
        <li>Properties available for lease, not yet occupied</li>
        <li>Buildings listed for sale</li>
        <li>Buildings awaiting renovation</li>
        <li>Vacant land</li>
      </ul>

      <h3 className="h3">UNACCEPTABLE EXPOSURES</h3>
      <ul>
        <li>Condemned buildings</li>
        <li>Buildings intended for demolition</li>
        <li>Risks in bankruptcy, receivership or with unpaid taxes/ liens</li>
        <li>Existing or unrepaired damage (fire, smoke, water, etc)</li>
        <li>Urban vacant lots</li>
      </ul>

      <h3 className="h3">COVERAGES AVAILABLE</h3>
      <ul>
        <li>
          Commercial Package (Property & General Liability) – can also be
          written as monoline Property or Liability
        </li>
        <li>$1M/ $2M General Liablity Limits</li>
        <li>No GL deductible</li>
        <li>Property capacity up to $20M TIV per risk**</li>
        <li>
          Special Form and Replacement Cost available (depending on risk
          characteristics)
        </li>
        <li>Short term policies available (3, 6, 9 months)</li>
        <li>Can consider minor renovations (such as tenant build outs)</li>
        <li>Excess Limits available</li>
      </ul>

      <h3 className="h3">SUBMISSION REQUIREMENTS</h3>
      <ul>
        <li>ACORD Applications</li>
        <li>
          Supplemental Vacant Building application (PHLY E&S or competitor’s
          equivalent)
        </li>
        <li>Currently valued insurance company loss runs, minimum 3 years</li>
        <li>Desired terms & conditions</li>
      </ul>

      <h3 className="h3">FINANCIAL SECURITY</h3>
      <ul>
        <li>AM Best rated A++</li>
        <li>Standard & Poor’s assigned A+</li>
      </ul>

      <p className="text-[1.6rem] mt-16">
        ** Capacity varies by construction type and sprinkler protection.
        Maximum capacity is for MNC or better, 100% sprinklered. Frame
        construction is limited to $3M (non-sprinklered) or $5M (100%
        sprinklered).
      </p>
    </CoverageTemplate>
  </Layout>
)

export default CoverageVacantBuildingsPage
